import { Accordion as AccordionDefault, useAccordion } from "./Accordion";
import * as Panel from "./Panel";

export const Accordion = {
  Default: AccordionDefault,
  useAccordion,
  ...Panel,
};
